import React, { useCallback, useRef, useState, useMemo } from "react";
import { connect } from "react-redux";
import { LoadPanel } from "devextreme-react/load-panel";
import DropDownButton from 'devextreme-react/drop-down-button';
import { Button, Popup } from 'devextreme-react';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import axios from "axios";
import { alert, confirm } from 'devextreme/ui/dialog';
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule,
    StateStoring

} from "devextreme-react/data-grid";
import {MESSAGES} from "../../../../common/Messages";

function ItemRateScheduleDialog(props) {
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [selectedRateId, setSelectedRateId] = useState(null);
    const [selectedDetail, setSelectedDetail] = useState([]);
    const hideLoadPanel = useCallback(() => setLoadPanelVisible(false), []);
    const [recordCount, setRecordCount] = useState(1); // For input
    const rateDetailLoadUrl = "wm/RateScheduleHeader/Get";
    const position = { of: "#accordion-containe2" };
    const gridDetailRef = useRef(null);
    const gridRateDetailRef = useRef(null);
    const loadUrlDetailItems = "wm/TransactionDetail/GetTransactionDetails";
    // handleGenerateClick used to live here: it called back into
    // ValidateTransactionBeforeStageChange to move the stage once the user was done with this dialog.
    // It was never bound to a button, so that path was dead and the stage never moved.
    //
    // It is gone rather than wired up, because moving the stage was never this dialog's job. Delphi
    // opened WMD0054 *after* the stage was already set to 'C' (uWMD0002.pas:6555-6556), and
    // SelectItemRateSchedule (:10365-10419) never touched the stage on either OK or Cancel. The caller
    // now moves the stage first and opens this dialog afterwards as a side-trip.
    const onDetailItemSelectionChanged = useCallback((e) => {
        
        const selected = e.selectedRowsData[0];
        setSelectedDetail(selected || []);
    }, []);
    const detailItemDataSource = useMemo(() => createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${loadUrlDetailItems}`,
        loadParams: {
            transactionRowId: props.headerId,
            // sort: JSON.stringify([{ selector: "keysequence", desc: false }])
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.headerId,
            };
        },


    }), [props.headerId]);
    const onGridContentReady = useCallback((e) => {
        
        const grid = gridDetailRef.current?.instance;
        if (grid) {
            const selectedRows = grid.getSelectedRowKeys();
            if (!selectedRows || selectedRows.length === 0) {
                grid.selectRowsByIndexes([0]); // Select first row
            }
        }
    }, []);
    const rateDetailDataSource = useMemo(() => createStore({
        key: 'rowId',
        loadUrl: `${window._env_.REACT_APP_APIS}/${rateDetailLoadUrl}`,
        loadParams: {
            customerId: props?.customerId,
            itemId: selectedDetail?.itemId,
            lotId: selectedDetail?.lotId,
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
            };
        },
    }), [selectedDetail]);

    const selectionFilter = ['checked', '=', true];
    const handleSelectionChange = useCallback(async (e) => {
        

        // Get selected rows (returns a Promise)
        const selected = await e.component.getSelectedRowsData();

        if (selected.length > 0) {
            const selectedRow = selected[0]; // Only one if you're enforcing single select
            setSelectedRateId(selectedRow.rowId);
            // setSelectedDetail(selectedRow); // If you want to store it
        } else {
            console.log(MESSAGES.NO_ROW_SELECTED);
        }
    }, []);

    const onRateDetailGridContentReady = useCallback(async (e) => {
        const grid = e.component;
        const selectedRows = await grid.getSelectedRowsData();
        if (selectedRows.length > 0) {
            const selectedRow = selectedRows[0];
            setSelectedRateId(selectedRow.rowId); // Sync state
        }
    }, []);

    const applyItemCharges = async () => {
        try {
            setLoadPanelVisible(true);
            const itemId = selectedDetail?.itemId;
            const rateScheduleHeaderRowId = selectedRateId;
            const url = `${window._env_.REACT_APP_APIS}/wm/RateScheduleHeader/ApplyItemCharges` +
                        `?itemId=${encodeURIComponent(itemId)}&rateScheduleHeaderRowId=${encodeURIComponent(rateScheduleHeaderRowId)}`;
            const response = await axios.post(
                url,
                {}, 
                {
                    headers: {
                        Authorization: `Bearer ${props.oidc.user.access_token}`,
                    },
                }
            );
    
            alert(MESSAGES.ITEM_CHARGES_APPLIED,MESSAGES.INFORMATION);
            props.setShowItemRateScheduleDialog(false);
    
        } catch (error) {
            console.error("Error:", error);
            alert(MESSAGES.ITEM_CHARGES_APPLY_ERROR,MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    };
    
    return (
        <div className="FormMt" style={{ height: "96%", display: "flex", flexDirection: "column", gap: "10px" }}>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />

            {/* Grid 1 */}
            <div style={{ flex: 1, overflow: "hidden" }}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    id="gridDetails"
                    dataSource={detailItemDataSource}
                    showBorders={true}
                    columnAutoWidth={true}
                    ref={gridDetailRef}
                    height="100%"
                    onSelectionChanged={onDetailItemSelectionChanged}
                    onContentReady={onGridContentReady}
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <StateStoring
                        enabled={true}
                        type="custom"
                    />
                    <Scrolling mode="standard" />
                    <Selection mode="single" />
                    <Export enabled={true} allowExportSelectedData={true} />
                    <Column dataField="itemCode" caption='Item' />
                    <Toolbar>
                        <Item location="before">
                            <div style={{ fontWeight: "bold", fontSize: "16px" }}>Please select the Item Rate Schedule for this Item from the list below</div>
                        </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                    </Toolbar>
                </DataGrid>
            </div>
            {/* Grid 2 */}
            <div style={{ flex: 1, overflow: "hidden" }}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={rateDetailDataSource}
                    showBorders={true}
                    columnAutoWidth={true}
                    height="100%"
                    ref={gridRateDetailRef}
                    defaultSelectionFilter={selectionFilter}
                    onSelectionChanged={handleSelectionChange}
                    onContentReady={onRateDetailGridContentReady}
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <StateStoring
                        enabled={true}
                        type="custom"
                    />
                    <Scrolling mode="standard" />
                    <Selection
                        mode="single"
                        deferred={true}
                    />
                    <Export enabled={true} allowExportSelectedData={true} />
                    <Column dataField="scheduleCode" caption="Rate Schedule" />
                    <Column dataField="description" caption="Description" />
                    <Toolbar>
                        <Item location="before">
                            <Button
                                text="Apply Item Charges"
                                useSubmitBehavior={true}
                                disabled={(selectedRateId == null)}
                                type="default"
                                className="accordianButton"
                                onClick={applyItemCharges}
                            />
                        </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                    </Toolbar>
                </DataGrid>
            </div>

        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(ItemRateScheduleDialog);
